module.exports = __webpack_public_path__ + "static/img/broadcastno.bdc6cb6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/meetingcontrol/common/broadcastno.png
// module id = Nj2e
// module chunks = 1